import React from 'react';
import PropTypes from 'prop-types';
import { keyName } from '@bingads-webui/keycode';
import { notificationApi } from '@bingads-webui-react/notification-center';
import { Label, FormGroup, Form, Button, ButtonToolbar } from '@bingads-webui-react/primitive';
import { Input } from '@bingads-webui-react/primitive-validation';

export class SaveFilterView extends React.PureComponent {
  static propTypes = {
    filterSchema: PropTypes.shape({
      entitySchema: PropTypes.shape({
        name: PropTypes.string,
        type: PropTypes.string,
      }),
      getFilterProperty: PropTypes.func,
    }).isRequired,
    i18n: PropTypes.shape({
      getString: PropTypes.func,
    }).isRequired,
    legacyI18n: PropTypes.shape({
      getString: PropTypes.func,
    }).isRequired,
    onCancelSaveFilter: PropTypes.func.isRequired,
    onSaveFilter: PropTypes.func.isRequired,
  };

  state = {
    filterName: null,
    isValid: false,
  };

  onSave = () => {
    this.props.onSaveFilter(this.state.filterName);
    notificationApi.showInfo(this.props.i18n.getString(_TL_('Your filter has been saved.')));
  }

  onCancel = () => {
    this.props.onCancelSaveFilter();
  }

  onKeyDown = (event) => {
    // save upon pressing enter
    if (event.key === keyName[13]) {
      event.preventDefault();
      if (this.state.isValid) {
        this.onSave();
      }
    }
  }

  validationProps = {
    schema: {
      properties: {
        filterName: {
          name: 'filterName',
          type: 'string',
          required: true,
        },
      },
      type: 'object',
    },
    i18n: this.props.legacyI18n,
    field: 'filterName',
    onValidate: (result) => {
      this.setState({
        isValid: result.isValid,
        filterName: result.data.filterName,
      });
    },
  };

  render() {
    return (
      <Form className="save-filter-view">
        <FormGroup className="save-filter-title">
          <Label>{this.props.i18n.getString(_TL_('New saved filter'))}</Label>
        </FormGroup>
        <FormGroup className="save-filter-name-title">
          <Label htmlFor="saved-filter-name">{this.props.i18n.getString(_TL_('Saved filter name'))}</Label>
        </FormGroup>
        <FormGroup className="save-filter-name">
          <Input id="saved-filter-name" validationProps={this.validationProps} onKeyDown={this.onKeyDownHandler} />
        </FormGroup>
        <ButtonToolbar>
          <Button btnStyle="primary" disabled={!this.state.isValid} onClick={this.onSave}>{this.props.i18n.getString(_TL_('Save'))}</Button>
          <Button onClick={this.onCancel}>{this.props.i18n.getString(_TL_('Cancel'))}</Button>
        </ButtonToolbar>
      </Form>
    );
  }
}
